/**
 * SELFIES — shrink a photo on the phone before it's sent, so it travels fast
 * and the server never holds a full-size picture of anyone.
 * Output: a 4:5 portrait JPEG, 360×450, centre-cropped, as a data URL.
 */
export async function shrinkPhoto(file, width = 360, height = 450, quality = 0.82) {
    // Big phone photos (50 megapixels on some Androids) can run a browser out of
    // memory if decoded in full. Ask for a small decode first where we can.
    try {
        const bmp = await createImageBitmap(file, { resizeWidth: width * 2, resizeQuality: "medium", imageOrientation: "from-image" });
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (ctx) {
            const scale = Math.max(width / bmp.width, height / bmp.height);
            const w = bmp.width * scale;
            const h = bmp.height * scale;
            ctx.drawImage(bmp, (width - w) / 2, (height - h) / 2, w, h);
            bmp.close();
            return canvas.toDataURL("image/jpeg", quality);
        }
    }
    catch {
        /* older browsers: decode it the ordinary way below */
    }
    const url = URL.createObjectURL(file);
    try {
        const img = await new Promise((resolve, reject) => {
            const i = new Image();
            i.onload = () => resolve(i);
            i.onerror = () => reject(new Error("That photo couldn't be read."));
            i.src = url;
        });
        const canvas = document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        const ctx = canvas.getContext("2d");
        if (!ctx)
            throw new Error("This phone can't prepare photos.");
        // Centre-crop to the frame's shape.
        const scale = Math.max(width / img.naturalWidth, height / img.naturalHeight);
        const w = img.naturalWidth * scale;
        const h = img.naturalHeight * scale;
        ctx.drawImage(img, (width - w) / 2, (height - h) / 2, w, h);
        return canvas.toDataURL("image/jpeg", quality);
    }
    finally {
        URL.revokeObjectURL(url);
    }
}
/** A player's photo address, if they have one and photos are on. */
export function photoOf(castle, playerId) {
    return castle.photos?.enabled ? (castle.photos.urls[playerId] ?? null) : null;
}
//# sourceMappingURL=photo.js.map